/**
 * Assets Marquee — double infinite marquee
 *
 * Row 1 (.assets-marquee__track--ltr) scrolls right.
 * Row 2 (.assets-marquee__track--rtl) scrolls left.
 *
 * Relies on window.gsap exposed by main.js.
 */
( function () {
	const DURATION = 95; // base loop duration — higher = slower

	const mm = gsap.matchMedia();

	mm.add( '(prefers-reduced-motion: no-preference)', () => {
		document.querySelectorAll( '.assets-marquee' ).forEach( ( el ) => {
			const trackLtr = el.querySelector( '.assets-marquee__track--ltr' );
			const trackRtl = el.querySelector( '.assets-marquee__track--rtl' );

			if ( ! trackLtr || ! trackRtl ) return;

			gsap.set( trackLtr, { xPercent: -50 } );
			const tweenLtr = gsap.to( trackLtr, {
				xPercent : 0,
				ease     : 'none',
				duration : DURATION,
				repeat   : -1,
				paused   : true,
			} );

			const tweenRtl = gsap.to( trackRtl, {
				xPercent : -50,
				ease     : 'none',
				duration : DURATION,
				repeat   : -1,
				paused   : true,
			} );

			// Play only when visible
			const observer = new IntersectionObserver( ( [ entry ] ) => {
				if ( entry.isIntersecting ) {
					tweenLtr.play();
					tweenRtl.play();
				} else {
					tweenLtr.pause();
					tweenRtl.pause();
				}
			}, { threshold: 0 } );

			observer.observe( el );

			// Cleanup when matchMedia reverts
			return () => {
				tweenLtr.kill();
				tweenRtl.kill();
				observer.disconnect();
			};
		} );
	} );
} )();
